export const RemindTo = Object.freeze({
	Myself: 'myself',
	Creator: 'creator',
	Responsible: 'responsible',
	Accomplice: 'accomplice',
});

export const RemindBy = Object.freeze({
	Deadline: 'deadline',
	Date: 'date',
});

export const RemindVia = Object.freeze({
	Notification: 'notification',
	Email: 'email',
});
